/**
 * PMS API 모델
 *
 * OpenAPI generator 로 만들던 타입을 실제 사용하는 것만 추려 옮긴 파일이다.
 * 서버 스펙 변경 시 직접 수정한다.
 */

export interface AddFavoriteBody {
  fid?: number;
}

export interface EmptyResponse {
  data: object;
}

export interface FavoriteFolderDto {
  fid: number;
  name: string;
  order: number;
  favoriteCount: number;
  images: Array<string>;
}

export interface FavoriteFoldersResponse {
  data: Array<FavoriteFolderDto>;
}

export interface GeoDto {
  lat: number;
  lon: number;
  dongId: number;
  address?: string;
}

export interface PriceModel {
  pid: string; // 메루카리 상품 아이디
  priceJpy: number; // 메루카리 판매가 (엔)
  exchangeRate: number; // 엔 원 환률 (소수점 최대 5자리 절삭)
  shopShippingFeeJpy?: number; // B2C 상품 일본 국내 배송비 (단위: 엔)
  shopShippingFeeKrw?: number; // B2C 상품 일본 국내 배송비 (단위: 원)
  shippingFeeKrw: number; // 배송비 (원)
  dutyTaxKrw: number; // 관부가세 (원)
  bunjangMarkupPriceKrw: number; // 번개장터 마크업 가격 (원)
  proxyMarkupPriceKrw: number; // 프록시 마크업 가격 (원)
  opsCostJpy: number; // ops (엔)
  proxyAndShippingFeeKrw: number; // 노출용 구매대행 및 배송수수료 (원): proxy mark-up(8% + 600yen)  + 배송비
  priceKrw: number; // 노출용 판매 가격 (원): 최종결제금액 - 구매대행 및 배송수수료 - 관부가세
  discountRate?: number; // 메루카리 프로모션 할인률 (%)
}

export interface PriceOfferModel {
  id: number; // 가격 제안 ID
  status: PriceOfferModelStatusEnum; // 가격 제안 상태값
  isValid: boolean; // 가격 제안 ID가 유효 한지 여부
}

export const PriceOfferModelStatusEnum = {
  NonExistsPriceOffer: 'NON_EXISTS_PRICE_OFFER',
  ExpiredPriceOffer: 'EXPIRED_PRICE_OFFER',
  OfferAccepted: 'OFFER_ACCEPTED',
  CounterOffer: 'COUNTER_OFFER',
} as const;
export type PriceOfferModelStatusEnum = (typeof PriceOfferModelStatusEnum)[keyof typeof PriceOfferModelStatusEnum];

export interface ProductBenefitModel {
  benefitType: ProductBenefitModelBenefitTypeEnum;
  benefits: Array<string>;
  inspectionOptions: Array<ProductBenefitModelInspectionOptionsEnum>;
  inspectionKeyword?: string;
}

export const ProductBenefitModelBenefitTypeEnum = {
  Shop: 'SHOP',
  Service: 'SERVICE',
  CommercialOnly: 'COMMERCIAL_ONLY',
} as const;
export type ProductBenefitModelBenefitTypeEnum =
  (typeof ProductBenefitModelBenefitTypeEnum)[keyof typeof ProductBenefitModelBenefitTypeEnum];

export const ProductBenefitModelInspectionOptionsEnum = {
  ShoeClean: 'SHOE_CLEAN',
  Polishing: 'POLISHING',
  LeatherClean: 'LEATHER_CLEAN',
  Inspection: 'INSPECTION',
  Laundrygo: 'LAUNDRYGO',
} as const;
export type ProductBenefitModelInspectionOptionsEnum =
  (typeof ProductBenefitModelInspectionOptionsEnum)[keyof typeof ProductBenefitModelInspectionOptionsEnum];

export interface ProductBrandModel {
  id?: number;
  isVerified: boolean;
}

export interface ProductBunpayModel {
  enabled: boolean; // 번개페이 버튼 렌더링 여부
  shipping: boolean; // 번개페이 옵션 : 택배거래
  inPerson: boolean; // 번개페이 옵션 : 직거래
}

export interface ProductCommonModel {
  name: string;
  description: string;
  customDescription?: string; // 어드민에서만 설정 가능
  priceOfferEnabled?: boolean; // 가격 제안 허용 여부
  status?: ProductCommonModelStatusEnum;
  condition?: ProductCommonModelConditionEnum;
  keywords: Array<string>;
  namePrefix?: string;
  exportNaverShopping: boolean;
  isHidden?: boolean;
}

export const ProductCommonModelConditionEnum = {
  Undefined: 'UNDEFINED',
  New: 'NEW',
  Used: 'USED',
  LikeNew: 'LIKE_NEW',
  LightlyUsed: 'LIGHTLY_USED',
  HeavilyUsed: 'HEAVILY_USED',
  Damaged: 'DAMAGED',
} as const;
export type ProductCommonModelConditionEnum =
  (typeof ProductCommonModelConditionEnum)[keyof typeof ProductCommonModelConditionEnum];

export const ProductCommonModelStatusEnum = {
  New: 'NEW',
  Used: 'USED',
} as const;
export type ProductCommonModelStatusEnum =
  (typeof ProductCommonModelStatusEnum)[keyof typeof ProductCommonModelStatusEnum];

export interface ProductDescriptionResponse {
  data: ProductMercariDescription;
}

export interface ProductDetailResponse {
  data: ProductMercariDetailModel;
}

export interface ProductDiscountModel {
  status: ProductDiscountModelStatusEnum; // 할인 상태 (0: 대기중, 1: 할인중, 2: 종료됨, 3: 강제 종료됨)
  rate?: number; // 할인율, 단위(%), null 이면 정액 할인
  price?: number; // 할인된 가격
  originPrice?: number; // 할인 전 가격
  startAt?: Date; // 할인 시작 시각
  endAt?: Date; // 할인 종료 시각
  reason?: string; // 강제 종료 사유
  modifiedAt: Date; // 할인 정보 변경 시각
}

export const ProductDiscountModelStatusEnum = {
  Waiting: 'WAITING',
  InProgress: 'IN_PROGRESS',
  Ended: 'ENDED',
  ForcedTerminated: 'FORCED_TERMINATED',
  Reserved: 'RESERVED',
} as const;
export type ProductDiscountModelStatusEnum =
  (typeof ProductDiscountModelStatusEnum)[keyof typeof ProductDiscountModelStatusEnum];

export interface ProductImageModel {
  paths: Array<string>;
}

export interface ProductInspectionModel {
  status?: ProductInspectionModelStatusEnum;
  brand?: ProductInspectionModelBrand;
  model?: ProductInspectionModelInfo;
}

export interface ProductInspectionModelBrand {
  id: number;
  name: string;
  nameKor: string;
  nameEng: string;
  imageUrl: string;
}

export interface ProductInspectionModelInfo {
  id: number;
  name: string;
  sku: string;
  imageUrl: string;
}

export const ProductInspectionModelStatusEnum = {
  OptIn: 'OPT_IN',
  OptOut: 'OPT_OUT',
  NonTarget: 'NON_TARGET',
  Inspected: 'INSPECTED',
} as const;
export type ProductInspectionModelStatusEnum =
  (typeof ProductInspectionModelStatusEnum)[keyof typeof ProductInspectionModelStatusEnum];

export interface ProductLocationModel {
  geo?: GeoDto;
}

export interface ProductMediaModel {
  imageId: number;
  videoId?: number;
  durationMillis?: number; // 동영상 길이, 동영상인 경우에만 존재
}

export interface ProductMercariDescription {
  pid: number;
  descriptionJp: string;
}

export interface ProductMercariDetailModel {
  product: ProductMercariDetailModelProduct;
  payBenefit?: ProductMercariDetailModelPayBenefit;
  shop: ProductMercariDetailModelShop;
  couponText?: string; // 쿠폰 배너, null 이면 미노출 (https://quicket.atlassian.net/wiki/spaces/BUN/pages/3982688313/24+12_)
  bgztSamsungcardBenefit?: SamsungCardBenefit;
}

export interface ProductMercariDetailModelBrand {
  id?: number; // 번개장터 브랜드 아이디
  name: string; // 브랜드명 (한국어 or 영어)
}

export interface ProductMercariDetailModelCategory {
  id: string; // 번개장터 카테고리 아이디
  name: string; // 카테고리명 (한국어 or 영어)
}

export interface ProductMercariDetailModelDiscount {
  rate: number;
}

export interface ProductMercariDetailModelPayBenefit {
  iconUrl: string; // icon
  title: string; // 결제 혜택
  contents: Array<string>; // 기본 content
  moreContents: Array<string>; // 기본 contents 노출수가 정해져 있는 경우, 해당 필드를 통해 추가 contents 정보를 제공
}

export interface ProductMercariDetailModelProduct {
  pid: number; // 번개장터 상품 아이디
  mercariPid: string; // 메루카리 상품 아이디
  name: string; // 상품 이름 (한국어)
  discount?: ProductMercariDetailModelDiscount;
  description: string; // 상품 설명 (한국어)
  price: number; // 번개장터 판매 가격 (원)
  originPrice: number; // 번개장터 판매 가격, 프로모션 미적용 (원)
  proxyAndShippingFee: number; // 노출용 구매대행 및 배송수수료 (원): proxy mark-up(8% + 600yen)  + 배송비
  location: string; // 지역 이름 (한국어)
  brand?: ProductMercariDetailModelBrand;
  category: ProductMercariDetailModelCategory;
  categories: Array<ProductMercariDetailModelCategory>; // 상위 카테고리를 포함한 카테고리 list 정보
  saleStatus: ProductMercariDetailModelProductSaleStatusEnum; // 판매상태
  condition: ProductMercariDetailModelProductConditionEnum; // 상품상태
  size?: string; // 사이즈
  qty: number; // 메루카리 상품은 수량이 1개이다.
  image: ProductMercariDetailModelProductImage;
  metric: ProductMercariDetailModelProductMetric;
  favorite?: boolean; // viewer 의 찜 여부
  updatedAt: Date; // 상품 수정된 시각
  updatedBefore: string; // 상품 수정된 시각 문자로 변환 (한국어)
}

export const ProductMercariDetailModelProductConditionEnum = {
  Undefined: 'UNDEFINED',
  New: 'NEW',
  Used: 'USED',
  LikeNew: 'LIKE_NEW',
  LightlyUsed: 'LIGHTLY_USED',
  HeavilyUsed: 'HEAVILY_USED',
  Damaged: 'DAMAGED',
} as const;
export type ProductMercariDetailModelProductConditionEnum =
  (typeof ProductMercariDetailModelProductConditionEnum)[keyof typeof ProductMercariDetailModelProductConditionEnum];

export interface ProductMercariDetailModelProductImage {
  url: string; // 포맷: `$baseUrl/product/${pid}_{cnt}_${mTime}_w{res}.jpg`  ${pid}, ${mTime} 은 서버 에서 설정. ${cnt}, ${res} 를 변경 해서 사용 필요.  cnt 범위 : 1 <= cnt <= count
  count: number;
}

export interface ProductMercariDetailModelProductMetric {
  favoriteCount: number; // 찜 개수
}

export const ProductMercariDetailModelProductSaleStatusEnum = {
  Selling: 'SELLING',
  Reserved: 'RESERVED',
  SoldOut: 'SOLD_OUT',
} as const;
export type ProductMercariDetailModelProductSaleStatusEnum =
  (typeof ProductMercariDetailModelProductSaleStatusEnum)[keyof typeof ProductMercariDetailModelProductSaleStatusEnum];

export interface ProductMercariDetailModelShop {
  uid: number; // 번개장터 상점 아이디
  mercariUid?: number; // 메루카리 상점 아이디
  shopId?: string; // 메루카리 B2C 상점 아이디
}

export interface ProductMetricsModel {
  commentCount: number;
  viewCount: number;
  favoriteCount: number;
}

export interface ProductOption {
  optionValueId: number;
  value?: string;
  optionValue?: string; // 상품 조회시 필요한 product_option_value 의 value
  optionGroupId?: string; // 상품 조회시 필요한 product_option_group 의 정보  최 상위 (root) 그룹의 정보를 제공 한다.
  optionGroupName?: string;
  childOptionGroupId?: string; // 상품 조회시 필요한 product_option_group 의 정보  두 번째 그룹의 정보를 제공 한다.
}

export interface ProductPeriodicPricingModel {
  isEnabled: boolean;
  startDate?: string;
  intervalInHours?: number;
  discountPrice?: number;
  lastPrice?: number;
}

export interface ProductTradeModel {
  freeShipping?: boolean; // 무료배송 여부
  shippingSpecs?: { [key: string]: ShippingSpec }; // **배송 정보**  - key: 배송 유형  - value: 배송 상세 정보, 현재 배송비만 제공.
  isDefaultShippingFee?: boolean; // 다음 등록시에도 사용 여부, Request Model에서 사용
  inPerson: boolean; // 직거래 가능 여부
  detailedAddress?: string; // 직거래 상세 주소
  isPrevVersion: boolean; // 거래방법 세분화 도입 전의 데이터 인지 여부
  shippingFee?: number; // 일반 배송비
}

export interface ProductTransactionModel {
  price?: number; // 상품 조회시, request 에 buyerUid 가 있으면 제안된 가격 필드로 사용
  originPrice?: number; // 상품 조회시, request 에 buyerUid 가 있으면 원래 가격 필드로 사용
  priceOffer?: PriceOfferModel;
  quantity?: number;
  exchangeable: boolean;
  includeShippingCost: boolean;
  shippingFee?: number;
  trade?: ProductTradeModel;
  negotiable?: boolean; // [price] 협상 가능. deprecated field 이므로 언제든지 삭제 될 수 있음
  mercari?: PriceModel;
}

export interface ProductV2Model {
  pid: number;
  uid: number;
  type: ProductV2ModelTypeEnum;
  category: ProductV2ModelCategoryEnum;
  categoryId: string;
  categoryName: string;
  saleStatus?: ProductV2ModelSaleStatusEnum;
  imageUrlTemplate: string;
  imageCount: number;
  videoUrlTemplate?: string;
  videoSeq?: Array<number>;
  care: boolean;
  common?: ProductCommonModel;
  transaction?: ProductTransactionModel;
  location?: ProductLocationModel;
  image?: ProductImageModel;
  media?: Array<ProductMediaModel>;
  inspection?: ProductInspectionModel;
  periodicPricing?: ProductPeriodicPricingModel;
  option?: Array<ProductOption>; // 작성일: 2023.12.21  필드 이름으로 options를 구 버전에서 사용중이기 때문에 이름을 options 로 변경하면 안됨  release 버전 기준은 AOS (10.3.0) / IOS (10.3.0)) 으로 예상됨  추후 주석 수정
  brand?: ProductBrandModel;
  bunpay?: ProductBunpayModel;
  metrics?: ProductMetricsModel;
  proshop?: ProshopModel;
  benefits?: Array<ProductBenefitModel>;
  createdAt: Date;
  upAt: Date;
  modifiedAt: Date;
  isCashable: boolean; // 환금성 여부
  inTimeSale?: boolean; // 타임세일 중인지 여부 - 웹, mams-api 에서 사용중, GET /api/pms/v2/products/{pid} 에서만 사용
  discount?: ProductDiscountModel;
  mercari?: ProductV2ModelProductMercariModel;
}

export const ProductV2ModelCategoryEnum = {
  Bunjang: 'BUNJANG',
  Mercari: 'MERCARI',
} as const;
export type ProductV2ModelCategoryEnum = (typeof ProductV2ModelCategoryEnum)[keyof typeof ProductV2ModelCategoryEnum];

export interface ProductV2ModelProductMercariModel {
  shopId?: string;
  variantId?: string;
  variantSize?: string;
  brandName?: string; // 단건 조회시, 메루카리 PDP SEO 에서 사용
}

export const ProductV2ModelSaleStatusEnum = {
  Selling: 'SELLING',
  Reserved: 'RESERVED',
  Deleted: 'DELETED',
  SoldOut: 'SOLD_OUT',
} as const;
export type ProductV2ModelSaleStatusEnum =
  (typeof ProductV2ModelSaleStatusEnum)[keyof typeof ProductV2ModelSaleStatusEnum];

export const ProductV2ModelTypeEnum = {
  Basic: 'BASIC',
  Care: 'CARE',
  Mercari: 'MERCARI',
  Edition1: 'EDITION1',
} as const;
export type ProductV2ModelTypeEnum = (typeof ProductV2ModelTypeEnum)[keyof typeof ProductV2ModelTypeEnum];

export interface ProductV2Response {
  data: ProductV2Model;
}

export interface ProshopModel {
  isProshop: boolean;
}

export interface SamsungCardBenefit {
  iconUrl: string; // 번개장터 삼성카드 icon url
  title: string; // 혜택 타이틀 (ex: 번개장터 삼성카드 혜택)
  contents: Array<TextModel>; // 혜택 contents (TextModel 리스트)
  appUrl: string; // CMS 번개장터 삼성카드 이벤트 콘텐츠 app url (앱 번개장터 상품 PDP 에서 사용)
  webUrl: string; // CMS 번개장터 삼성카드 이벤트 콘텐츠 web url (메루카리 PDP에서 사용)
}

export interface ShippingSpec {
  fee: number; // 배송비
}

export interface Text {
  text: string;
  attribute?: TextAttribute;
  key?: string;
  appUrl?: string;
}

export interface TextAttribute {
  typography?: string;
  color: string;
  style?: string;
}

export interface TextModel {
  main: Text;
  sub?: Array<Text>;
}
